<template>
  <div class="d-flex justify-content-center mt-3">
    <div class="card p-6 form-card shadow-sm">

      <!-- User Name -->
      <div class="mb-3">
        <label class="form-label ">
          User Name <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          placeholder="User Name"
          v-model="userNameInput"
          autocomplete="off"
          @input="errors.userName = ''"
        />
        <small class="text-danger">{{ errors.userName }}</small>
      </div>

      <!-- Name -->
      <div class="mb-3">
        <label class="form-label ">
          Name <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          placeholder="Name"
          v-model="nameInput"
          autocomplete="off"
          @input="validateName(); errors.name = ''"
        />
        <small class="text-danger">{{ errors.name }}</small>
      </div>

      <!-- Password -->
      <div class="mb-3 position-relative">
        <label class="form-label ">
          Password <span class="text-danger">*</span>
        </label>
        <input
          :type="showPassword ? 'text' : 'password'"
          autocomplete="new-password"
          class="form-control pe-5"
          placeholder="Password"
          v-model="passwordInput"
          @input="errors.password = ''"
        />
        <span class="eye-icon" @click="showPassword = !showPassword">
          <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
        </span>
        <small class="text-danger">{{ errors.password }}</small>
      </div>

      <!-- Role -->
      <!-- <div class="mb-3">
        <label class="form-label ">
          RoleId <span class="text-danger">*</span>
        </label>
        <el-select
          v-model="selectedRoles"
          placeholder="Please select role"
          class="w-100"
          @change="errors.role = ''"
        >
          <el-option
            v-for="item in roleList"
            :key="item.key"
            :label="item.name"
            :value="item.key"
          />
        </el-select>
        <small class="text-danger">{{ errors.role }}</small>
      </div> -->

      <!-- Domain -->
      <div class="mb-3">
        <label class="form-label ">
          Domain<span class="text-danger">*</span>
        </label>
        <el-select
          v-model="selectedDomain"
          placeholder="Please select domain"
          class="w-100"
          @change="errors.domain = ''"
        >
          <el-option
            v-for="item in domainList"
            :key="item.key"
            :label="item.name"
            :value="item.key"
          />
        </el-select>
        <small class="text-danger">{{ errors.domain }}</small>
      </div>

      <!-- Customer Account -->
      <div class="mb-3">
        <label class="form-label">
          Customer Account <span class="text-danger">*</span>
        </label>
        <el-select
          v-model="selectedCustomer"
          multiple
          filterable
          collapse-tags
          collapse-tags-tooltip
          placeholder="Please select customer account"
          class="w-100"
          @change="errors.customer = ''"
        >
          <el-option
            v-for="item in sortedCustomerList"
            :key="item.key"
            :label="item.name"
            :value="item.key"
          />
        </el-select>
        <small class="text-danger">{{ errors.customer }}</small>
      </div>

      <div class="mb-3">
        <el-checkbox v-model="invoiceScanning">
          <div class="form-label">
            Invoice Scanning
          </div>
        </el-checkbox>
      </div>
      <!-- Button -->
      <button
            class="btn btn-primary px-4 d-flex align-items-center justify-content-center"
            @click="submit"
            :disabled="isLoading"
      >
        <span v-if="!isLoading">Save</span>
        <!-- Loader -->
        <span v-else class="spinner-border spinner-border-sm"></span>
      </button>

    </div>
  </div>

  <!-- Toast -->
  <div
    v-if="showToastFlag"
    :class="['toast-box', toastType === 'success' ? 'bg-success' : 'bg-danger']"
  >
    {{ toastMessage }}
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import store from "@/store";

export default defineComponent({
  name: "NewUser",

  setup() {
    let mailid = store.getters.emailid;
    let domainName = store.getters.DomainName.toLowerCase();
    let id = store.getters.UserId;
    // ✅ Reactive variables
    const userNameInput = ref("");
    const nameInput = ref("");
    const passwordInput = ref("");
    const selectedRoles = ref([]); // selected values
    const selectedDomain = ref([]); // selected values
    const selectedCustomer = ref([]); // selected values
    const domainList = ref([]);      // dropdown list
    const roleList = ref([]);      // dropdown list
    const customerList = ref([]);      // dropdown list
    const errors = ref({
    userName: "",
    name: "",
    password: "",
    role: "",
    customer: "",
    });

    const toastMessage = ref("");
    const toastType = ref(""); // success / error
    const showToastFlag = ref(false);
    const showPassword = ref(false);
    const invoiceScanning = ref(false);
    const isLoading = ref(false);    

    onMounted(() => {
      setCurrentPageBreadcrumbs("New User", ["NA"]);
    });

    const sortedCustomerList = computed(() => {
      return [...customerList.value].sort((a, b) => {
        const aSelected = selectedCustomer.value.includes(a.key);
        const bSelected = selectedCustomer.value.includes(b.key);

        if (aSelected && !bSelected) return -1;
        if (!aSelected && bSelected) return 1;

        return a.name.localeCompare(b.name);
      });
    });

    ApiService.get( "api/users/getUserRoleId" )
      .then((resp) => {
         roleList.value = resp.data.usermodel.map((a) => ({
            key: a.role_id,
            name: a.role_id, // adjust if API uses different field
          }));
      })
      .catch((a) => {
        console.log("API Error", a);
      });

    ApiService.get( `api/users/getClient/${id}/${domainName}` )
      .then((resp) => {
         customerList.value = resp.data.usermodel.map((a) => ({
            key: a.id,
            name: a.username, // adjust if API uses different field
          }));
          domainList.value = resp.data.domainmodel.map((a) => ({
            key: a.DomainId,
            name: a.DomainName
          }));
      })
      .catch((a) => {
        console.log("API Error", a);
      });

    const validateForm = () => {
        let isValid = true;

        errors.value = {
            userName: "",
            name: "",
            password: "",
            role: "",
            customer: "",
            domain: "",
        };

        if (!userNameInput.value) {
            errors.value.userName = "User Name is required";
            isValid = false;
        }

        if (!nameInput.value) {
            errors.value.name = "Name is required";
            isValid = false;
        }

        if (!passwordInput.value) {
            errors.value.password = "Password is required";
            isValid = false;
        }

        // if (!selectedRoles.value || selectedRoles.value.length == 0) {
        //     errors.value.role = "Role is required";
        //     isValid = false;
        // }

        if (!selectedCustomer.value || selectedCustomer.value.length == 0) {
            errors.value.customer = "Customer Account is required";
            isValid = false;
        }

        if (!selectedDomain.value || selectedDomain.value.length == 0) {
            errors.value.domain = "Domain is required";
            isValid = false;
        }

        return isValid;
    };

    const validateName = () => {
    // Allow only alphabets and space
    nameInput.value = nameInput.value.replace(/[^a-zA-Z\s]/g, "");
    };

    // ✅ Submit function
    const submit = async () => {
      console.log(invoiceScanning.value,'invoice scanning value')
        if (!validateForm()) return;
        isLoading.value = true; // ✅ start loading
        const payload = {
            username: userNameInput.value,
            firstname: nameInput.value,
            password: passwordInput.value,
            role_id: 10, /*selectedRoles.value,*/
            domainid: selectedDomain.value, /*selectedRoles.value,*/
            accountid: selectedCustomer.value.join('|'),
            last_update_user: mailid,
            DomainName: "",
            invoicescanning: invoiceScanning.value
        };

        try {
            const resp = await ApiService.post("api/users/addUpdateUser", payload);

            if (resp.data.usermodel[0].resStatus === "S") {
                showToast(resp.data.usermodel[0].resMessage, "success");

                // clear form
                userNameInput.value = "";
                nameInput.value = "";
                passwordInput.value = "";
                selectedRoles.value = [];
                selectedDomain.value = [];
                selectedCustomer.value = [];
                invoiceScanning.value = false;
            } else {
                showToast(resp.data.usermodel[0].resMessage, "error");
            }
        } catch (e) {
            showToast("Something went wrong", "error");
        } finally {
            isLoading.value = false; // ✅ stop loading
        }
    };

    const showToast = (msg, type) => {
        toastMessage.value = msg;
        toastType.value = type;
        showToastFlag.value = true;

        setTimeout(() => {
            showToastFlag.value = false;
        }, 3000);
    };

    return {
        userNameInput,
        invoiceScanning,
        nameInput,
        passwordInput,
        selectedRoles,
        selectedDomain,
        selectedCustomer,
        sortedCustomerList,
        roleList,
        domainList,
        customerList,
        submit,
        validateName,
        errors,
        showToastFlag,
        toastMessage,
        toastType,
        showPassword,
        isLoading,
    };
  },
});
</script>
<style scoped>
    .form-card {
        width: 350px;
        border-radius: 10px;
    }

    .form-label{
        color: rgb(46, 49, 146)
    }

    .toast-box {
        position: fixed;
        bottom: 20px;
        right: 20px;
        color: white;
        padding: 12px 20px;
        border-radius: 5px;
        z-index: 9999;
    }

    .text-danger {
        font-size: 12px;
    }

    .eye-icon {
        position: absolute;
        right: 15px;
        top: 38px;
        cursor: pointer;
        color: #6c757d;
    }
</style>